import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    if (!this.hasContentTarget) return

    // アニメーションのスタイル設定
    this.contentTarget.style.transition = "max-height 0.3s ease-in-out, opacity 0.3s ease-in-out"
    this.contentTarget.style.overflow = "hidden"

    // 初期状態がhiddenの場合（閉じた状態）、またはスタイルで閉じられている場合
    if (this.contentTarget.classList.contains("hidden") || this.contentTarget.style.maxHeight === "0px") {
      this.contentTarget.style.maxHeight = "0px"
      this.contentTarget.style.opacity = "0"
      this.contentTarget.classList.remove("hidden")
    } else {
      // 既に開いている場合
      this.contentTarget.style.maxHeight = `${this.contentTarget.scrollHeight}px`
      this.contentTarget.style.opacity = "1"
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("rotate-180")
      }
    }
  }

  toggle(event) {
    // ボタンやリンクがクリックされた場合はアコーディオンを開閉しない
    if (event.target.closest('a, button') && event.target.closest('[data-action="click->accordion#toggle"]') !== event.target) {
      return
    }

    if (this.contentTarget.style.maxHeight === "0px") {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.contentTarget.style.maxHeight = `${this.contentTarget.scrollHeight}px`
    this.contentTarget.style.opacity = "1"
    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180")
    }
  }

  close() {
    this.contentTarget.style.maxHeight = "0"
    this.contentTarget.style.opacity = "0"
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180")
    }
  }
}
